import { LoaderFunctionArgs, useLoaderData } from 'react-router-dom'
import { TreatmentRecord, fetchTreatment } from '../../api/treatments'

function Attribute({ label, value }: { label: string; value: string | number | null }) {
  return (
    <p>
      <strong>{label}</strong> {value}
    </p>
  )
}

export function loader({ params }: LoaderFunctionArgs): Promise<TreatmentRecord> {
  return fetchTreatment(Number(params.healthCenterId), params.patientId as string, params.treatmentId as string)
}

export default function TreatmentShowPage() {
  const treatment = useLoaderData() as Awaited<ReturnType<typeof loader>>

  return (
    <div>
      <Attribute label="Nombre:" value={treatment.name} />
      <Attribute label="Código:" value={treatment.code} />
      <Attribute label="Precio:" value={treatment.price} />
      <Attribute label="Descripción:" value={treatment.description} />
      <Attribute label="Nota:" value={treatment.note} />
      <Attribute label="Cuotas:" value={treatment.fee} />
      <Attribute label="Paciente:" value={treatment.patient_id} />
    </div>
  )
}
